import { Box, Image, Text, VStack } from "@chakra-ui/react";
import background from "../../assets/image/p3-bg.png";
import bubble from "../../assets/image/p3-bubble.png";
import mainImg from "../../assets/image/p3-main.gif";

const HeaderPage3 = () => {
    return (
        <>
            <Box
                mb="6rem"
            >
                <Image
                    src={background} 
                    w="100vw"
                    h="520px"
                    zIndex="-1"
                />
                <Box
                    position="absolute"
                    top="100px"
                    left="2.5vw"
                    w="95vw"
                >
                    <Image 
                        src={bubble} 
                        w="90%"
                        h="150px"
                        zIndex=""
                        left="5%"
                        position="absolute"
                    />
                    <VStack
                        spacing="1em"
                        position="absolute"
                        w="100%"
                    >
                        <Text 
                            fontSize="18px"
                            color="black"
                            w="100%"
                            align="center"
                            margin={0}
                            mt="1em"
                        >
                            「跟我走～我帶你認識兔子家族」
                        </Text>
                        <Text 
                            fontSize="16px"
                            color="black"
                            w="80%"
                            left="10%"
                            align="center"
                        >
                            領頭兔帶你參觀家族的各種社團，而你被哪一些社團吸引呢？
                        </Text>
                    </VStack>
                    <Image 
                        src={mainImg} 
                        w="100%"
                        h="auto"
                        zIndex=""
                        mt="9rem"
                    />
                </Box>
            </Box>
        </>
    );
}

export default HeaderPage3;